import type * as React from 'react';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * Builds the pinned box for a fixed-width column so table layout cannot shrink or grow it.
 */
export function createFixedColumnStyle(width: string): React.CSSProperties {
	return { width, minWidth: width, maxWidth: width };
}

export function isTextTruncated(textRef: HTMLSpanElement | null) {
	if (!textRef) return false;
	return textRef.scrollWidth > textRef.clientWidth;
}
